export enum SubscriptionStatus {
  ACTIVE = 'Active',
  CANCELED = 'Canceled',
  PENDING = 'Pending',
  PAST_DUE = 'PastDue',
  TRIAL = 'Trial',
  TRIAL_UPGRADE = 'TrialUpgrade',
}
